import { TRANSPORT_VENDORS } from './mockTransportVendorData';

/** Completed trips awaiting finance clearance — vendor cross-ref from Vendor Master */
export const PENDING_SETTLEMENT_TRIPS = [
  {
    tripId: 'TRP-9021',
    vendorId: 'VND-786',
    calculatedFreightAed: 7200,
    vendorInvoiceAed: 7200,
    payoutApproved: false,
  },
  {
    tripId: 'TRP-9022',
    vendorId: 'VND-442',
    calculatedFreightAed: 9100,
    vendorInvoiceAed: 9350,
    payoutApproved: false,
  },
  {
    tripId: 'TRP-9023',
    vendorId: 'VND-651',
    calculatedFreightAed: 4800,
    vendorInvoiceAed: 4800,
    payoutApproved: false,
  },
  {
    tripId: 'TRP-9024',
    vendorId: 'VND-105',
    calculatedFreightAed: 6500,
    vendorInvoiceAed: 6820,
    payoutApproved: false,
  },
  {
    tripId: 'TRP-9025',
    vendorId: 'VND-786',
    calculatedFreightAed: 5400,
    vendorInvoiceAed: 5400,
    payoutApproved: false,
  },
];

export function resolveVendorName(vendorId) {
  return TRANSPORT_VENDORS.find((v) => v.vendorId === vendorId)?.companyName || vendorId;
}

export function computeVariance(calculated, invoiced) {
  return Math.round((invoiced - calculated) * 100) / 100;
}

/** Tank blending cost model — AED per metric ton */
export const BLENDING_COST_MODEL = {
  baseProductCostPerMt: 2840,
  terminalBlendingFeePerMt: 95,
  transportFreightPerMt: 118,
  uaeMarketTradingPricePerMt: 3125,
};

export function computeBlendingTotals(model = BLENDING_COST_MODEL) {
  const totalDeliveredCost =
    model.baseProductCostPerMt + model.terminalBlendingFeePerMt + model.transportFreightPerMt;
  const netMargin = model.uaeMarketTradingPricePerMt - totalDeliveredCost;
  const marginPct = Math.round((netMargin / model.uaeMarketTradingPricePerMt) * 1000) / 10;
  return { totalDeliveredCost, netMargin, marginPct };
}
